import { ethers } from "ethers";
import Web3 from "web3";
import { Web3Auth } from "@web3auth/modal";
import environmentVariables from "../config/environmentVariables.js";
import { WALLET_ADAPTERS, CHAIN_NAMESPACES } from "@web3auth/base";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import {
  mldStakingAbi,
  mldStakingAddress,
  mldTokenAddress,
  usdtTokenAddress,
  mldTokenABI,
  lordTokenAddress,
  lordTokenABI,
  nftStakingAddress,
  nftStakingABI,
  metalordNFTManagerAddress,
  metalordNFTManagerABI,
  metaspaceNFTMarketplaceAddress,
  metaspaceNFTMarketplaceABI,
  usdtTokenABI,
  signatureCreationAddress,
  signatureCreationABI,
  SwapingContract,
  swapingContractAbi,
} from "./data.js";
import axios from "axios";
import { getRPCURL } from "./common.js";
import { to } from "react-spring";

const clientId = environmentVariables?.clientId;

export const init = async () => {
  try {
  // const rpcUrl= getRPCURL();
  // console.log(rpcUrl)
    const privateKeyProvider=new EthereumPrivateKeyProvider({
      config: {
        chainConfig: {
          chainNamespace: CHAIN_NAMESPACES.EIP155,
          chainId: "0x89",
          rpcTarget: "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e",
        },
      },
    });
    const web3auth = new Web3Auth({
      clientId: clientId,
      web3AuthNetwork: "aqua", // mainnet, aqua, celeste, cyan or testnet
      privateKeyProvider,
      chainConfig: {
        chainNamespace: CHAIN_NAMESPACES.EIP155,
        chainId: "0x89",
        rpcTarget:
          "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e",
      },
      uiConfig: {
        loginMethodsOrder: ["google", "facebook", "email_passwordless"],
      },
      // adapterSettings: {
      //   openlogin: {
      //     loginMethods: {
      //       google: {
      //         name: "Google",
      //         showOnModal: true,
      //       },
      //       facebook: {
      //         name: "Facebook",
      //         showOnModal: true,
      //       },
      //       email_passwordless: {
      //         name: "Email",
      //         showOnModal: true,
      //       },
      //       // Hide all others
      //       // apple: { showOnModal: false , showOnDesktop: false, mainOption: false },
      //       // github: { showOnModal: false },
      //       // twitter: { showOnModal: false },
      //       // linkedin: { showOnModal: false },
      //       // reddit: { showOnModal: false },
      //       // discord: { showOnModal: false },
      //       // twitch: { showOnModal: false },
      //       // wechat: { showOnModal: false },
      //       // email_password: { showOnModal: false },
      //       // sms_passwordless: { showOnModal: false },
      //       // ...add any others you want to hide
      //     },
      //   },
      // },
    });

    await web3auth.initModal();

    const web3authProvider = await web3auth.connect();

    const userInfo=await web3auth.getUserInfo();
    console.log(userInfo, "<------------------------------------------------------------userInfo from web3auth");
    const provider = new ethers.BrowserProvider(web3authProvider);
    const signer = await provider.getSigner();
    const privateKey = await web3authProvider?.request({
      method: "eth_private_key", // secure method to get the private key
    });
    const address = await signer.getAddress();
    const idToken=await web3auth.authenticateUser();
    await saveUserInformation(userInfo,address)
    
    
    // console.log(idToken,web3authProvider,userInfo,address,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')

    const mldStakingContract = new ethers.Contract(
      mldStakingAddress,
      mldStakingAbi,
      signer
    );
    const mldTokenContract = new ethers.Contract(
      mldTokenAddress,
      mldTokenABI,
      signer
    );

    const swapTokenContract = new ethers.Contract(
      SwapingContract,
      swapingContractAbi,
      signer
    )

    const usdtTokenContract = new ethers.Contract(
      usdtTokenAddress,
      mldTokenABI,
      signer
    );
    const lordTokenContract = new ethers.Contract(
      lordTokenAddress,
      lordTokenABI,
      signer
    );
    const nftStakingContract = new ethers.Contract(
      nftStakingAddress,
      nftStakingABI,
      signer
    );
    const metalordNFTManagerContract = new ethers.Contract(
      metalordNFTManagerAddress,
      metalordNFTManagerABI,
      signer
    );
    const signatureCreationContract = new ethers.Contract(
      signatureCreationAddress,
      signatureCreationABI,
      signer
    )
    const metaspaceNFTMarketplaceContract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      signer
    );

    const mldBal = await balanceOf(mldTokenContract, address);
    const lordBal = await balanceOf(lordTokenContract, address);
    const usdtBal = await balanceOf(usdtTokenContract, address);
    const maticBal = await getBalance(provider, address);
    const mldAllowance = await checkAllowance(
      mldTokenContract,
      address,
      mldStakingAddress
    );
    const usdtAllowance = await checkAllowance(
      usdtTokenContract,
      address,
      mldStakingAddress
    );
    const mldMarketPlaceAllowance = await checkAllowance(
      mldTokenContract,
      address,
      metaspaceNFTMarketplaceAddress
    );
    const usdtMarketPlaceAllowance = await checkAllowance(
      usdtTokenContract,
      address,
      metaspaceNFTMarketplaceAddress
    );

    const logout = async () => {
      return await web3auth.logout();
    };

    // const permitData= await createSignaturePermit(
    //   mldTokenContract,
    //   address,
    //   mldTokenAddress,
    //   "0xF916A36BcB1E9bf3BE77B02159dD33fE28586F0f",
    //   provider,
    //   privateKey
    // );
    // console.log(permitData, "<---------------------------------permitData");

    return {
      provider,
      signer,
      address,
      mldBal,
      mldAllowance,
      mldMarketPlaceAllowance,
      usdtMarketPlaceAllowance,
      usdtBal,
      usdtAllowance,
      maticBal,
      lordBal,
      metalordNFTManagerContract,
      metaspaceNFTMarketplaceContract,
      signatureCreationContract,
      mldStakingContract,
      mldTokenContract,
      usdtTokenContract,
      lordTokenContract,
      nftStakingContract,
      userInfo,
      idToken,
      swapTokenContract,
      // permitData,
      logout,
    };
  } catch (error) {
    console.error(error);
    return false;
  }
};

// export const OwnershipTransferred=async (prevadd,newadd)=>{
//   return await lordTokenContract.OwnershipTransferred(prevadd,newadd);
// }

export const transferOwnership = async (nftmarket, userAddress) => {
  return await nftmarket.transferOwnership(userAddress);
};

export const balanceOf = async (lordTokenContract, userAddress) => {
  if(!userAddress)
    return 0;
  return await lordTokenContract.balanceOf(userAddress);
};

export const getBalance = async (provider, userAddress) => {
  if(!userAddress)
    return 0;
  return await provider.getBalance(userAddress);
};

export const sendToken = async (
  provider,
  lordTokenContract,
  userAddress,
  amount
) => {
  let maxFeePerGas = (await provider.getFeeData()).maxFeePerGas;
  let maxPriorityFeePerGas = (await provider.getFeeData()).maxPriorityFeePerGas;
  const tx = await lordTokenContract.transfer(userAddress, amount, {
    maxFeePerGas: maxFeePerGas + BigInt(5000000000),
    maxPriorityFeePerGas: maxPriorityFeePerGas + BigInt(4000000000),
  });
  const rec = await tx.wait();
  return rec;
};


export const gasEstimate = async (
  contract,
  userAddress,
  amount,
  currencyName
) => {
  try {
    const web3 = new Web3(
      "https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e"
    );
    let tokenAddress;
    let tokenABI;

    if (currencyName == "MLD") {
      tokenABI = mldTokenABI;
      tokenAddress = mldTokenAddress;
    } else if (currencyName == "LORD") {
      tokenABI = lordTokenABI;
      tokenAddress = lordTokenAddress;
    } else if (currencyName == "USDT") {
      tokenABI = usdtTokenABI;
      tokenAddress = usdtTokenAddress;
    }
    // const gasPrice = await contract?.provider.getGasPrice();
    // console.log(
    //   parseFloat(BigInt(gasPrice) / 1000000000000000000n),
    //   "----------------------------------------"
    // );
    // const gasFees = await contract?.mldTokenContract.methods
    //   .transfer(userAddress, amount)
    //   .estimateGas({ from: contract?.address });
    // console.log(gasFees, "---------------------------------------------");
    // if (gasPrice !== undefined && gasFees !== undefined) {
    //   const gasPriceEther = parseFloat(
    //     ethers.formatUnits(gasPrice, "ether")
    //   );
    //   const totalGasCostEther = gasPriceEther * gasFees;

    //   return totalGasCostEther;
    // } else {
    //   // Handle the case where gas price or gas fees are undefined
    //   throw new Error("Gas price or gas fees are undefined");
    // }
    const tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);

    ///////////////////////////////////// start Recive Notification ///////////////////////////////

    //  function handleTransaction(transaction) {
    //   console.log('Received transaction:');
    //   console.log('Transaction hash:', transaction.hash);
    //   console.log('From:', transaction.from);
    //   console.log('To:', transaction.to);
    //   console.log('Value (wei):', transaction.value.toString());
    // }

    // contract.events.Transfer({ filter: {}, fromBlock: 'latest' })
    //   .on('data', (event) => {
    //     console.log('Incoming Transaction:', event);
    //   })
    //   .on('error', (error) => {
    //     console.error('getting transaction Error Incoming Transaction:', error);
    //   });

    //////////////////////////////////// End Recive Notification ////////////////////////////

    const data = tokenContract?.methods
      .transfer(userAddress, amount)
      .encodeABI();
    const gasPrice = await web3.eth.getGasPrice();
    const transactionObject = {
      from: contract?.address,
      to: tokenAddress,
      data: data,
    };
    const gasEstimate = await web3.eth.estimateGas(transactionObject);
    const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    return gasprice;
    // .then(async (gasEstimate) => {
    //   const gasprice = parseFloat((gasPrice * gasEstimate) / 1e18);
    //   return gasprice;
    // })
    // .catch((err) => {
    //   throw new Error("undefined values");
    // });
  } catch (err) {
    console.log(err, "error");
  }
};
export const checkAllowance = async (
  lordTokenContract,
  userAddress,
  spender
) => {
  return await lordTokenContract.allowance(userAddress, spender);
};

export const approve = async (contract, spender,provider) => {
  try{
    let maxFeePerGas=(await provider.getFeeData()).maxFeePerGas;
  let maxPriorityFeePerGas=(await provider.getFeeData()).maxPriorityFeePerGas;
  const tx = await contract.approve(
    spender,
    BigInt("111111111111111111111111111111111111111111111111111111"),
    {
    maxFeePerGas: maxFeePerGas + BigInt(5000000000),
    maxPriorityFeePerGas: maxPriorityFeePerGas + BigInt(4000000000),
  });
  const rec = await tx.wait(1);
  return rec;
  }catch(err){
    console.log(err)
  }
};

export const createSignaturePermit = async (mldContract,userAddress,mldAddress, spender,provider,privateKey) => {
  try{
    const nonce = await mldContract.nonces(userAddress);
    const rpcProvider = new ethers.JsonRpcProvider("https://polygon-mainnet.infura.io/v3/a8460c2c0aca48fa96e428d41e7cd71e")
    const walletUser=new ethers.Wallet(privateKey,rpcProvider)
    const deadline = Math.floor(Date.now() / 1000) + 60 * 60; // 1 hour from now
  const value = "115792089237316195423570985008687907853269984665640564039457";
  
  const domain =   {
      name: "MetalordToken",
      version: "1",
      chainId: 137, // Adjust the chain ID as needed
      verifyingContract: mldAddress,
  }

  const types =  {
      Permit: [
          { name: "owner", type: "address" },
          { name: "spender", type: "address" },
          { name: "value", type: "uint256" },
          { name: "nonce", type: "uint256" },
          { name: "deadline", type: "uint256" },
      ],
  };

  const message = {
    owner: userAddress,
    spender: spender,
    value: value,
    nonce: nonce,
    deadline: deadline,
  };

  const signature=await walletUser.signTypedData(domain, types, message);
  console.log(signature, "<---------------------------------permitData");
  // console.log(signaturusereData, "<---------------------------------permitData");
  let data={
    signature: signature,
    userAddress: userAddress,
    deadline: deadline,
    value: value,
  }
  let config={
    method:"post",
    url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/gasless/permitnew`,
    data:data,
  }
  const respoinse= await axios.request(config)
  console.log(respoinse, "<---------------------------------permitData");
  return {
    owner: userAddress,
  };
  }catch (error) {
    console.error("Error creating signature permit:", error);
  }
}

export const saveUserInformation = async (userInfo,address) => {
  try{
    if(!userInfo) {
      console.error("No user information provided");
      return false;
    }
    let name="";
    if(userInfo?.name==null||userInfo?.name==undefined||userInfo?.name==""){
      name=userInfo?.email.split("@")[0];
    }else{
      name=userInfo?.name;
    }
    let data={
       appState:userInfo?.appState,
        email:userInfo?.email,
        aggregateVerifier:userInfo?.aggregateVerifier,
        name:name,
        profileImage:userInfo?.profileImage,
        typeOfLogin:userInfo?.typeOfLogin,
        verifier:userInfo?.verifier,
        verifierId:userInfo?.verifierId,
        dappShare:userInfo?.dappShare,
        oAuthIdToken:userInfo?.oAuthIdToken,
        oAuthAccessToken:userInfo?.oAuthAccessToken,
        isMfaEnabled:userInfo?.isMfaEnabled,
        idToken:userInfo?.idToken,
        walletAddress:address
    }
    let config={
      method:"post",
      url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/save/user/web3auth`,
      data:data,
    }
    const response=await axios.request(config);
    console.log(response, "<---------------------------------saveUserInformation");
  }catch(error){
    console.error("Error saving user information:", error);
    return false
  }
}

export const getRate=async (swapContract,from,to)=>{
    try{
      const rate =  await swapContract.getRate(from,to)
      return ethers.formatEther(rate.toString());
    }catch(err){
      console.log(err);
    }
}

export const getPairKey=async (swapContract,from,to)=>{
  try{
    return await swapContract.getPairKey(from,to)
  }catch(err){
    console.log(err)
  }
}

export const getExpectedOutput=async (swapContract,from ,to, amount)=>{
  try{
    return await swapContract.getExpectedOutput(from,to,amount)
  }catch(err){
    console.log(err)
  }
}

export const swapTokens=async (swapContract,from,to,amount)=>{
  try{
    const tx=await swapContract.swap(from,to,amount);
    const rec=await tx.wait(1)
    return rec;
  }catch(error){
    console.log(("Error:", error?.reason || error?.message || "Unknown error"))
    return error?.reason || error?.message || "Unknown error";
  }
}